import { useVisibleAreaBox } from "./hooks/use-visible-area-box.ts";
import { SVG_STYLES } from "./settings.ts";

interface VisibleAreaBox {
  panelHeight: number;
  panelWidth: number;
  scale: number;
}

export const VisibleAreaBox = ({ scale, panelHeight, panelWidth }: VisibleAreaBox) => {
  const { x, y, width, height } = useVisibleAreaBox(scale, panelHeight, panelWidth);

  return <rect width={Math.round(width)} height={height} x={x} y={y} {...SVG_STYLES.visibleRegion} fillOpacity={0.2} />;
};
